var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "myworks" },
    [
      _vm.worksList.length
        ? _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.worksList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "workBox col col-sm-6 col-md-4" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "team_member",
                      class: _vm.device == "mobile" ? "mobileStyle" : "",
                      on: {
                        click: function ($event) {
                          return _vm.goToSeeItem(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "entry",
                          on: {
                            click: function ($event) {
                              return _vm.goWorksDetail(item.id)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "img-responsive",
                            attrs: {
                              src:
                                item.type == "Python"
                                  ? _vm.pythonCover
                                  : item.cover,
                              alt: "",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lawyer" },
                        [
                          _c("div", { staticClass: "lawyerInfo" }, [
                            _c("h3", [_vm._v(_vm._s(item.name))]),
                            _vm._v(" "),
                            _c("div", { staticClass: "lawyer-details" }, [
                              _c("div", { staticClass: "user-panel" }, [
                                _c("ul", { staticClass: "user-eyes" }, [
                                  _c("li", { staticClass: "likes" }, [
                                    _c("span", { staticClass: "like" }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          item.likeNum ? item.likeNum : 0
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", { staticClass: "eyes" }, [
                                    _c("i", { staticClass: "el-icon-view" }),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.visNum) +
                                        "\n                  "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.publish == "已发布"
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type:
                                      item.match && item.match.id
                                        ? "info"
                                        : "success",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      item.match && item.match.id
                                        ? ""
                                        : _vm.showSignUpDialog(item, index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.match && item.match.id
                                        ? "已参赛"
                                        : "报名参赛"
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.publish != "收藏夹"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editWorks(item)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.publish != "收藏夹"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteWorks(item.id)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          )
        : _c("span", { staticClass: "default" }, [
            _c("img", {
              attrs: { src: require("@/assets/icon/notdata.png"), alt: "" },
            }),
            _vm._v("\n    暂时没有作品\n  "),
          ]),
      _vm._v(" "),
      _vm.totalPages > 1
        ? _c("el-pagination", {
            attrs: {
              background: "",
              "page-size": _vm.pageSize,
              "current-page": _vm.pageNumber,
              "page-count": _vm.totalPages,
              layout: "total, prev, pager, next",
              total: _vm.totalElements,
            },
            on: { "current-change": _vm.handleCurrentChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "defaultDialog",
        {
          ref: "signUpDialog",
          attrs: { title: "报名参赛", width: "920px" },
          on: { close: _vm.signUpDialogClose },
        },
        [
          _c(
            "el-form",
            {
              ref: "signUpForm",
              attrs: {
                model: _vm.signUpFormData,
                rules: _vm.signUpFormDataRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "赛事：", prop: "matchId" } },
                        [
                          _c("defaultSelect", {
                            attrs: {
                              dataList: _vm.matchListData,
                              placeholder: "选择赛事",
                              propKey: _vm.defaultProps,
                              className: "width160",
                              size: "small",
                            },
                            on: { change: _vm.matchChange },
                            model: {
                              value: _vm.signUpFormData.matchId,
                              callback: function ($$v) {
                                _vm.$set(_vm.signUpFormData, "matchId", $$v)
                              },
                              expression: "signUpFormData.matchId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "赛项：", prop: "matchItemId" } },
                        [
                          _c("defaultSelect", {
                            attrs: {
                              dataList: _vm.matchItemListData,
                              placeholder: "选择赛项：",
                              propKey: _vm.defaultProps,
                              className: "width160",
                              size: "small",
                            },
                            on: { change: _vm.matchItemChange },
                            model: {
                              value: _vm.signUpFormData.matchItemId,
                              callback: function ($$v) {
                                _vm.$set(_vm.signUpFormData, "matchItemId", $$v)
                              },
                              expression: "signUpFormData.matchItemId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "组别：", prop: "matchItemGroupId" },
                        },
                        [
                          _c("defaultSelect", {
                            attrs: {
                              dataList: _vm.matchItemGroupListData,
                              placeholder: "选择组别",
                              propKey: _vm.defaultProps,
                              className: "width160",
                              size: "small",
                            },
                            model: {
                              value: _vm.signUpFormData.matchItemGroupId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.signUpFormData,
                                  "matchItemGroupId",
                                  $$v
                                )
                              },
                              expression: "signUpFormData.matchItemGroupId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "学校：", prop: "school" } },
                        [
                          _c("el-input", {
                            staticClass: "width160",
                            attrs: { placeholder: "请输入所在学校" },
                            model: {
                              value: _vm.signUpFormData.school,
                              callback: function ($$v) {
                                _vm.$set(_vm.signUpFormData, "school", $$v)
                              },
                              expression: "signUpFormData.school",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 14 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "解说视频：", prop: "workVideoUrl" },
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.signUpFormData.workVideoUrl,
                                  expression: "signUpFormData.workVideoUrl",
                                },
                              ],
                              staticClass: "defaultUploadShowStyle",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "el-upload-list__item-status-label",
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-upload-success el-icon-check",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "el-icon-close",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.deleteVideo.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("video", {
                                staticClass: "showImg",
                                attrs: {
                                  width: "100%",
                                  src: _vm.signUpFormData.workVideoUrl,
                                  id: "guideVideo",
                                  controls: "controls",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("clickUpload", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.signUpFormData.workVideoUrl,
                                expression: "!signUpFormData.workVideoUrl",
                              },
                            ],
                            ref: "videoUploader",
                            attrs: {
                              drag: true,
                              uploadSize: 500,
                              accept:
                                ".mp4, .m3u8, .rmvb, .avi, .swf, .3gp, .mkv, .flv",
                              clearUploadedFile: true,
                              uploadPath: `/upload`,
                              noticeText:
                                "只能上传mp4/m3u8/rmvb/avi/avi/swf/3gp/mkv/flv文件，且不超过500MB",
                            },
                            on: { change: _vm.videoUpload },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图片：", prop: "workPictureList" } },
                [_c("CardUpload", { on: { change: _vm.changeImg } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "说明文档：", prop: "documentUrls" } },
                [
                  _c("clickUpload", {
                    ref: "docUploader",
                    attrs: {
                      limit: 3,
                      listType: "text",
                      drag: true,
                      uploadSize: 50,
                      accept: ".doc, .docx, .pdf, .ppt, .pptx",
                      uploadPath: `/uploadCourseware`,
                      noticeText:
                        "只能上传doc/docx/pdf/ppt/pptx文件，且不超过50MB",
                    },
                    on: { change: _vm.docsUpload, removed: _vm.removeDoc },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { align: "center", "label-width": "0" } },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.$refs.signUpDialog.visible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c("loadingBtn", {
                    attrs: { btnText: "报 名", size: "small" },
                    on: { click: _vm.signUp },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/myworks.vue?vue&type=template&id=5095a876&
// module id = null
// module chunks = 